export type ForecastPayloadItem = {
  month: number;
  year: number;
  validated_forecast: number;
};

export type EditableForecastItem = {
  month: number;
  year: number;
  forecastProposal?: number;
};

export const buildForecastPayload = (
  storeData: EditableForecastItem[] | undefined,
  isDestocking = false,
): ForecastPayloadItem[] =>
  (storeData ?? []).flatMap((item) => {
    if (typeof item.forecastProposal !== 'number') return [];

    const forecastPayload = {
      month: item.month,
      year: item.year,
      validated_forecast: item.forecastProposal,
    };

    return isDestocking
      ? [forecastPayload]
      : [{ ...forecastPayload }, { ...forecastPayload, year: item.year + 1 }];
  });
